import { render, staticRenderFns } from "./StatisticsProgram.vue?vue&type=template&id=e8f139f6&"
import script from "./StatisticsProgram.vue?vue&type=script&lang=js&"
export * from "./StatisticsProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports